
const canAddListener
  = window.Soda && window.Soda.setAppStateListener

let listeners = []

export function addListener(callback) {
  if (!callback || !canAddListener) return

  if (!listeners.includes(callback)) {
    listeners.unshift(callback)
  }

  return {
    remove() {
      removeListener(callback)
    }
  }
}

export function removeListener(callback) {
  listeners = listeners.filter(it => it !== callback)
}

export function onceListener(callback) {
  if (!callback || !canAddListener) return
  const handler = function(...args) {
    removeListener(handler)
    return callback(...args)
  }

  listeners.unshift(handler)
  return {
    remove() {
      removeListener(handler)
    }
  }
}

export function uninit() {
  window.Soda && window.Soda.setAppStateListener && window.Soda.setAppStateListener(false)
}

export function init() {
  if (canAddListener) {
    window.Soda.setAppStateListener(true, function(result = {}) {
      const { data = {} } = result || {}
      const {state = 0} = data || {}

      listeners.reduce(async (excuteNextHandler, handler) => {
        if (excuteNextHandler) {
          // 1: 开屏， 2: 锁屏
          const canNext = await handler(state)
          return canNext
        }
        return false
      }, true)
    })
  }
}

export default {
  init,
  uninit,
  addListener,
  removeListener,
  onceListener
}
